import { initMetricLogging } from "../typescript/modules/web-vitals-logger";

requestIdleCallback(() => {
	initMetricLogging();
}, { timeout: 100 });
